import React from 'react';
import AboutSection from '../components/AboutSection/AboutSection';
import WhyChooseUs from '../components/WhyChooseUs/WhyChooseUs';
import TestimonialsSection from '../components/TestimonialsSection/TestimonialsSection';
import PromoBanner from '../components/PromoBanner/PromoBanner';
import './PageHeader.css';

const AboutPage = () => {
  return (
    <main className="about-page">
      {/* Page Header Hero */}
      <div className="page-header-banner">
        <div className="page-header-container">
          <span className="page-header-tag">✦ ABOUT DEXA INNOVATION</span>
          <h1 className="page-header-title">Engineering Precision CNC Solutions & Industrial Outcomes</h1>
          <p className="page-header-subtitle">
            DEXA Innovation designs and deploys intelligent automation systems that optimize operations, reduce human error, and unlock scalable efficiency.
          </p>
        </div>
      </div>

      {/* Main Interactive About Section */}
      <AboutSection />

      {/* Why Choose DEXA Section */}
      <WhyChooseUs />

      {/* Testimonials */}
      <TestimonialsSection />

      {/* Promo Banner */}
      <PromoBanner />
    </main>
  );
};

export default AboutPage;
